"use strict";
/* eslint-disable import/no-cycle, camelcase */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../../rest"));
var combineLearningPanelFreeUrl_1 = __importDefault(require("./combineLearningPanelFreeUrl"));
var AwsAPIs = {
    getUserProfilePicture: function () {
        return rest_1.default.get({
            mockFunc: function () { return ({ url: 'https://picsum.photos/200' }); },
            url: (0, combineLearningPanelFreeUrl_1.default)('/users/profile-picture'),
        });
    },
    getUsersProfilePicture: function (body) {
        return rest_1.default.put({
            mockFunc: function () {
                var result = {};
                body.user_uuids.forEach(function (uuid) {
                    result[uuid] = 'https://picsum.photos/200';
                });
                return { urls: result };
            },
            url: (0, combineLearningPanelFreeUrl_1.default)('/users/profile-pictures'),
            body: body,
        });
    },
};
exports.default = AwsAPIs;
